import { Box } from "@primer/react";
import { ClockIcon } from "@primer/octicons-react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { EmptyState, LoadingPage } from "../../components";
import { useAccessControl } from "../../hooks/useAccessControl";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { rootActions } from "../../state/actions/rootActions";
import { eReducerStatusBase } from "../../state/reducer-model/eReducerStatusBase";
import QueueWaitingPage from "../queue/QueueWaitingPage";

/**
 * Smart landing — render theo state queue:
 *   - hasAccess    → redirect /classes
 *   - canPreview   → redirect /classes (preview only, appsettings AllowPreviewBeforeOpen=true)
 *   - inQueue      → render QueueWaitingPage
 *   - else         → empty state "chưa mở cổng"
 *
 * `periodClosed` đã handle ở route-level (ProtectedRoute → /closed).
 */
const LandingPage = () => {
    const dispatch = useAppDispatch();
    const { status, inQueue, hasAccess } = useAppSelector(s => s.queue);
    const { canPreview } = useAccessControl();

    useEffect(() => {
        if (status === eReducerStatusBase.is_not_initialization) {
            dispatch(rootActions.queue.LOAD_STATUS_START());
        }
    }, [dispatch, status]);

    if (status === eReducerStatusBase.is_loading || status === eReducerStatusBase.is_not_initialization) {
        return <LoadingPage message="Đang kiểm tra trạng thái cổng đăng ký..." />;
    }

    if (hasAccess) {
        return <Navigate to="/classes" replace />;
    }

    if (inQueue) {
        return <QueueWaitingPage />;
    }

    if (canPreview) {
        return <Navigate to="/classes" replace />;
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "calc(100vh - 200px)",
                px: 3,
                py: 5,
            }}
        >
            <EmptyState
                variant="card"
                icon={ClockIcon}
                title="Cổng đăng ký chưa mở"
                description="Vui lòng đợi quản trị viên mở cổng. Trang sẽ tự cập nhật khi cổng được mở."
            />
        </Box>
    );
};

export default LandingPage;
